export const ApiDef_EHRFlowsheetConfiguration = {
    _v1: {}
};
//# sourceMappingURL=api-def.js.map